import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchVendors = createAsyncThunk(
  "vendor/fetchVendors",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/vendors", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchVendorSubscriptions = createAsyncThunk(
  "vendor/fetchVendorSubscriptions ",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/vendor/get-subs", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createVendorSubcription = createAsyncThunk(
  "producer/createVendorSubcription",
  async (formData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.post("/vendor/create-sub", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteVendorSubscription = createAsyncThunk(
  "vendor/deleteVendorSubscription",
  async (Id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.delete(`/vendor/delete-sub/${Id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete subscription"
      );
    }
  }
);

export const updateVendorSubcription = createAsyncThunk(
  "producer/updateVendorSubcription",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.put(
        `/vendor/edit-sub/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchApprovedVendors = createAsyncThunk(
  "vendor/fetchApprovedVendors",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/approved-vendors", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchPendingVendors = createAsyncThunk(
  "vendor/fetchPendingVendors",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/pending-vendors", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchVendorById = createAsyncThunk(
  "vendor/fetchVendorById",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get(`/admin/view-vendor/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchApprovedProducts = createAsyncThunk(
  "vendor/fetchApprovedProducts",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/approved-products", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchPendingProduct = createAsyncThunk(
  "vendor/fetchPendingProduct",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/vendors/pending-approval", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const approveVendorProduct = createAsyncThunk(
  "vendor/approveVendorProduct",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.post(`/vendors/approve-product/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const declineVendorProduct = createAsyncThunk(
  "vendor/declineVendorProduct",
  async ({ id, reason }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.post(
        `/decline-vendor-product/${id}`,
        { reason },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const producersSlice = createSlice({
  name: "vendor",
  initialState: {
    vendors: [],
    vendorSubcriptions: [],
    approvedVendors: [],
    pendingVendors: [],
    vendorDetails: null,
    approvedProducts: [],
    pendingProducts: [],
    status: "idle",
    error: null,
    declineVendorProductStatus: "idle",
    declineVendorProductError: null,
    updateVendorSubscriptionStatus: "idle",
    updateVendorSubscriptionError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendors.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchVendors.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.vendors = action.payload.data;
      })
      .addCase(fetchVendors.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchVendorSubscriptions.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchVendorSubscriptions.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.vendorSubcriptions = action.payload.data;
      })
      .addCase(fetchVendorSubscriptions.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(createVendorSubcription.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createVendorSubcription.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.vendorSubcriptions.unshift(action.payload);
      })
      .addCase(createVendorSubcription.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchApprovedVendors.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchApprovedVendors.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.approvedVendors = action.payload.data;
      })
      .addCase(fetchApprovedVendors.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchPendingVendors.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchPendingVendors.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.pendingVendors = action.payload.data;
      })
      .addCase(fetchPendingVendors.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(fetchVendorById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchVendorById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.vendorDetails = action.payload;
      })
      .addCase(fetchVendorById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchApprovedProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchApprovedProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.approvedProducts = action.payload;
      })
      .addCase(fetchApprovedProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchPendingProduct.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPendingProduct.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.pendingProducts = action.payload;
      })
      .addCase(fetchPendingProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(approveVendorProduct.pending, (state) => {
        state.status = "loading";
      })
      .addCase(approveVendorProduct.fulfilled, (state) => {
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(approveVendorProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(declineVendorProduct.pending, (state) => {
        state.declineVendorProductStatus = "loading";
      })
      .addCase(declineVendorProduct.fulfilled, (state) => {
        state.declineVendorProductStatus = "succeeded";
      })
      .addCase(declineVendorProduct.rejected, (state, action) => {
        state.declineVendorProductStatus = "failed";
        state.declineVendorProductError = action.payload;
      })
      .addCase(updateVendorSubcription.pending, (state) => {
        state.updateVendorSubscriptionStatus = "loading";
        state.updateVendorSubscriptionError = null;
      })
      .addCase(updateVendorSubcription.fulfilled, (state, action) => {
        state.updateVendorSubscriptionStatus = "succeeded";

        const updatedSub = action.payload;
        const index = state.vendorSubcriptions.findIndex(
          (sub) => sub.id === updatedSub.id
        );
        if (index !== -1) {
          state.vendorSubcriptions[index] = updatedSub;
        }
      })
      .addCase(updateVendorSubcription.rejected, (state, action) => {
        state.updateVendorSubscriptionStatus = "failed";
        state.updateVendorSubscriptionError =
          action.payload || action.error.message;
      });
  },
});

export default producersSlice.reducer;
